import {CommonUrlService} from 'core/base/CommonUrlService';
import {get404Exception} from 'core/exceptions/NotFoundException';
import {RedirectControllerException} from 'core/exceptions/RedirectControllerException';
import {TAppInitialController} from 'core/redux/types';
import {actionSetBreadCrumbsList} from 'modules/breadcrumbs/slice';
import {categoriesRedirectController} from 'modules/categories/controller';
import {getCategoryLevelHelper, getCategoryNodeHelper} from 'modules/categories/helpers';
import {CollectionXService} from 'modules/collection-x/services/CollectionXService';
import {getCollections, getRelatedCollectionsList} from 'modules/collections/thunks';
import {CategoryType} from 'new-models';
import {ROUTER_QUERY_TAG_OR_COLLECTION_KEY} from 'plugins/modules/filter/constants';
import {COLLECTIONS_LIST_PAGE, PAGES} from 'routing/constants';

/**
 * Контроллер редирета для коллекций.
 * С помощью композиции, отлавливается `RedirectControllerException` и модифицируется `destination`
 * @param store
 * @param ctx
 * @throws RedirectControllerException;
 */
export const collectionsRedirectController: TAppInitialController<void> = async (store, ctx) => {
    try {
        await categoriesRedirectController(store, ctx);
    } catch (exception) {
        if (exception instanceof RedirectControllerException) {
            const destination = `${exception.destination}/${COLLECTIONS_LIST_PAGE}`;
            const statusCode = exception.statusCode;

            throw new RedirectControllerException('Collections redirect', {
                destination,
                statusCode,
            });
        }

        throw exception;
    }
};

export const collectionsControllerByCategory: TAppInitialController<void> = async (store, ctx) => {
    const {dispatch} = store;

    const categoryLevel = await getCategoryLevelHelper(store, ctx);
    const categoryNode = await getCategoryNodeHelper(store, ctx);

    if (!categoryNode || !categoryLevel) {
        return;
    }

    if (categoryNode.type !== CategoryType.Collection) {
        return;
    }

    const commonUrlService = new CommonUrlService(
        new URLSearchParams(),
        async (urlSearchParams) => {
            await dispatch(getCollections(urlSearchParams));
        },
        {
            query: ctx.query,
        }
    );

    await commonUrlService.hydrate();
};

export const relatedCollectionsController: TAppInitialController<void> = async (store, ctx) => {
    const {dispatch} = store;

    const category = await getCategoryNodeHelper(store, ctx);

    if (!category) {
        throw get404Exception();
    }

    const {collectionCode, collectionId} = CollectionXService.parseCollectionXUrl(
        <string>ctx.query[ROUTER_QUERY_TAG_OR_COLLECTION_KEY]
    );

    if (!collectionId || !collectionCode) {
        throw get404Exception();
    }

    await dispatch(getRelatedCollectionsList(new URLSearchParams(), collectionId, category.id));
};

export const collectionsPageController: TAppInitialController<void> = async ({dispatch}, ctx) => {
    dispatch(actionSetBreadCrumbsList([PAGES.HOME_PAGE, PAGES.COLLECTIONS_PAGE]));

    const commonUrlService = new CommonUrlService(
        new URLSearchParams(),
        async (urlSearchParams) => {
            await dispatch(getCollections(urlSearchParams));
        },
        {
            query: ctx.query,
        }
    );

    await commonUrlService.hydrate();
};
